import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const ArchiveModeTag = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const returnToTodaysGame = () => {
    history.push('/');
  };

  return (
    <div className="flex items-center w-full justify-center">
      <div className="flex flex-col items-center justify-center mt-2 bg-slate-200 px-2 py-1 rounded-md shadow-md w-3/6">
        <p className="text-sm font-bold dark:text-black">
          {t('archive.archiveMode')}
        </p>
        <button
          onClick={returnToTodaysGame}
          className="cursor-pointer text-blue-600 text-xs"
        >
          {t('archive.returnToToday')}
        </button>
      </div>
    </div>
  );
};

export default ArchiveModeTag;
